import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../contexts/AuthContext';
import './Announcements.css';

const Announcements = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [formData, setFormData] = useState({ title: '', content: '' });
  const { user } = useContext(AuthContext);

  const fetchAnnouncements = async () => {
    try {
      const res = await axios.get('/announcements');
      setAnnouncements(res.data);
    } catch (err) {
      console.error('获取公告失败:', err);
    }
  };

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editing) {
        await axios.put(`/announcements/${editing._id}`, formData);
      } else {
        await axios.post('/announcements', formData);
      }
      setFormData({ title: '', content: '' });
      setShowForm(false);
      setEditing(null);
      fetchAnnouncements();
    } catch (err) {
      console.error('操作失败:', err);
    }
  };

  const handleEdit = (announcement) => {
    setEditing(announcement);
    setFormData({ title: announcement.title, content: announcement.content });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('确定要删除这条公告吗？')) {
      try {
        await axios.delete(`/announcements/${id}`);
        fetchAnnouncements();
      } catch (err) {
        console.error('删除失败:', err);
      }
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString('zh-CN');
  };

  return (
    <div className="announcements">
      <h1>公告</h1>
      {user && (user.permission === '腐竹' || user.permission === '管理') && (
        <div className="admin-controls">
          <button onClick={() => setShowForm(!showForm)} className="btn-primary">
            {showForm ? '取消' : '发布公告'}
          </button>
        </div>
      )}

      {showForm && (
        <form onSubmit={handleSubmit} className="announcement-form">
          <input
            type="text"
            placeholder="公告标题"
            value={formData.title}
            onChange={(e) => setFormData({ ...formData, title: e.target.value })}
            required
          />
          <textarea
            placeholder="公告内容"
            value={formData.content}
            onChange={(e) => setFormData({ ...formData, content: e.target.value })}
            rows={6}
            required
          />
          <button type="submit" className="btn-primary">
            {editing ? '更新' : '发布'}
          </button>
        </form>
      )}

      <div className="announcements-list">
        {announcements.map((announcement) => (
          <div key={announcement._id} className="announcement-card">
            <div className="announcement-header">
              <h3>{announcement.title}</h3>
              <span className="announcement-date">{formatDate(announcement.createdAt)}</span>
            </div>
            <p className="announcement-content">{announcement.content}</p>
            {user && (user.permission === '腐竹' || user.permission === '管理') && (
              <div className="announcement-actions">
                <button onClick={() => handleEdit(announcement)} className="btn-edit">编辑</button>
                <button onClick={() => handleDelete(announcement._id)} className="btn-delete">删除</button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Announcements;
